// extracted by mini-css-extract-plugin
module.exports = {"bb":"bb__RFBEg","basket-item-controls__inline":"basket-item-controls__inline__2_kB_","basket-item-controls":"basket-item-controls__axEqa"};